import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-[12px] font-label font-semibold tracking-[0.2em] text-foreground-500 uppercase mb-4">
            Browse By
          </p>
          <h2 className="font-heading text-[42px] md:text-[56px] leading-[1.08] text-foreground-950 font-bold tracking-[-0.02em]">
            Explore Pandabuy
            <br />
            Spreadsheet Categories
          </h2>
          <p className="mt-4 text-[15px] text-foreground-600 leading-relaxed max-w-[520px]">
            Browse through our organized Pandabuy spreadsheet categories. Each category is
            hand-curated with the best finds, quality checks, and updated links.
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] cursor-pointer"
            >
              {/* Category Image */}
              <div className="relative w-full h-[180px] overflow-hidden bg-background-200">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} Pandabuy Spreadsheet Category`}
                  title={`Pandabuy Spreadsheet - ${cat.name} Finds`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>

              {/* Card Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center group-hover:bg-accent-100 transition-colors duration-300">
                    <i className={`${cat.icon} text-base text-foreground-600 group-hover:text-accent-600 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-[15px] font-label font-bold text-foreground-900 uppercase tracking-wide whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-[13px] text-foreground-500 leading-relaxed font-body line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-[12px] font-label font-semibold text-foreground-400 group-hover:text-primary-500 transition-colors duration-300">
                  <span>View Spreadsheet</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}